<button
  type="button"
  class="btn-blue-light-600 exercise-control-button"
  [disabled]="exerciseStatusPending"
  (click)="markAsAnswered($event)"
>
  {{ "COURSES.COURSE.EXERCISE.MARK_AS_SOLVED_BUTTON" | translate }}
</button>
